/**
 * Pure scoring helpers — no React, no DOM.
 * Mirrored on the server when computing max_score at insert time.
 */

import type { GameSpec, Scene, ScoringRules } from '@/types/gameSpec';

export function pointsForScene(scene: Scene, scoring: ScoringRules): number {
  return scene.points ?? scoring.correct;
}

export function computeMaxScore(spec: GameSpec): number {
  const base = spec.scenes.reduce(
    (sum, s) => sum + pointsForScene(s, spec.rules.scoring),
    0,
  );
  // streak bonus can theoretically apply to every scene after the first
  const streakUpper = (spec.rules.scoring.bonus_streak ?? 0) * Math.max(0, spec.scenes.length - 1);
  // time bonus is best-effort upper bound (assume finishing at t=0)
  const timeUpper = spec.rules.time_limit_seconds && spec.rules.scoring.time_bonus_per_sec
    ? spec.rules.scoring.time_bonus_per_sec * spec.rules.time_limit_seconds
    : 0;
  return Math.max(0, Math.round(base + streakUpper + timeUpper));
}

export function isWin(spec: GameSpec, score: number, maxScore: number): boolean {
  if (maxScore <= 0) return false;
  return score / maxScore >= spec.rules.pass_threshold;
}
